import { get } from 'lodash/fp';
import { createSelector } from 'reselect';

export const getROPicklistSearch = get(
  'reservation.components.ROPicklistSearch'
);

export const getROPicklistSearchQuery = createSelector(
  getROPicklistSearch,
  get('query')
);
